/*
 * @Date: 2023-05-31 14:38:02
 * @LastEditors: helen.deng helen.deng@trustasia.com
 * @Description:
 */
import $ from 'jquery';
import { Carousel } from 'bootstrap/dist/js/bootstrap.bundle.js';
import 'bootstrap/dist/css/bootstrap.css';
import '../common/css/index-page.less';

// const triggerTabList = [].slice.call(document.querySelectorAll("#myTab a"));
// triggerTabList.forEach(function (triggerEl) {
//   const tabTrigger = new Tab(triggerEl);

//   triggerEl.addEventListener("click", function (event) {
//     event.preventDefault();
//     tabTrigger.show();
//   });
// });

// 移动端菜单显示隐藏修复
// var myCollapse = document.getElementById('navbarNav');
// var bsCollapse = new Collapse(myCollapse, {
//   toggle: false
// });

// myCollapse.addEventListener('hide.bs.collapse', function () {
//   bsCollapse.hide();
// });

// 菜单切换
// $('#navbarNav .navbar-nav li').on('click', function () {
//   $(this).addClass("active").siblings().removeClass("active");
// });

$(function () {
  // 首页-证书优势轮播图
  var myCarousel = $('#indexPageCarousel');
  var carousel = new Carousel(myCarousel);

  var currentDate = Date.parse(new Date());

  myCarousel.find('.carousel-indicators [data-bs-target]').on('click', function () {
    var curr = this.dataset.bsSlideTo;
    carousel.to(curr);
  });

  $('.btn-login').on('click', () => {
    $.ajax({
      type: 'GET',
      url: '/api/v1/users/profile?time=' + currentDate,
      dataType: 'json',
      success: (res) => {
        if (res.code <= 99) {
          window.location.href = '/cert/products';
        } else {
          window.location.href = '/user/login';
        }
      },
      error: () => {
        // console.log('出现异常！');
        window.location.href = '/user/login';
      }
    });
  });

  // 展示版权信息
  $('.copyright').text(
    `Copyrights 2007 - ${new Date().getFullYear()} 亚数信息科技（上海）有限公司 版权所有`
  );
});
